import {
  CREATE_STORAGE_ITEM,
  DELETE_STORAGE_ITEM,
  RESTORE_STORAGE_ITEM,
  RETRIEVE_STORAGE_ITEMS,
  UPDATE_STORAGE_ITEM,
  UPDATE_STORAGE_ITEM_STATUS,
} from "../actions/types";

const initialState = { storageItems: [], totalStorageItemCount: 0 };

const storageItemsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case RETRIEVE_STORAGE_ITEMS:
      return {
        storageItems: payload.rows,
        totalStorageItemCount: payload.count,
      };

    case CREATE_STORAGE_ITEM:
      return payload;

    case UPDATE_STORAGE_ITEM:
      return payload;

    case UPDATE_STORAGE_ITEM_STATUS:
      console.log(payload);
      return {
        storageItems: payload.rows,
        totalStorageItemCount: payload.count,
      };

    case DELETE_STORAGE_ITEM:
      return {
        storageItems: payload.rows,
        totalStorageItemCount: payload.count,
      };

    case RESTORE_STORAGE_ITEM:
      return {
        storageItems: payload.rows,
        totalStorageItemCount: payload.count,
      };

    default:
      return state;
  }
};

export default storageItemsReducer;
